<template>
    <h4>HostFiledownloadTesting.vue</h4>
    <FileDownloadTesting></FileDownloadTesting>
  </template>
  
  <script>
  import FileDownloadTesting from "../Engineering/FileDownloadTesting.vue";

  export default {
    data() {return{};},
    created() {},
    components: { FileDownloadTesting },    
    computed: {},
    methods: {},
  };
  </script>
  
  <style scoped></style>
  